import React, { Component } from "react";
import { connect } from "react-redux";

import * as teamActions from "../team.actions";
import {
  getTopTeamScores,
  getCurrentUserTeamPosition
} from "../team.selectors";
import { getCurrentUser } from "../../user/user.selectors";

import Table from "../../common/components/Table";
import { Localize } from "../../../locale/localization";

class BestTeamsBlock extends Component {
  componentWillMount = () => {
    const { getTopTeams } = this.props;

    getTopTeams();
  };

  renderScoreRow = item => {
    const { position, score, team } = item;

    return (
      <tr key={position}>
        <td className="strong">{position}.</td>
        <td>{team.name}</td>
        <td>
          {score} {Localize("score.short")}
        </td>
      </tr>
    );
  };

  renderTableFooter = () => {
    const { currentUser, teamPosition } = this.props;
    if (!currentUser.team) {
      return null;
    }
    return (
      <tr>
        <td colSpan="3">
          {Localize("team.position.national")} {teamPosition}.
        </td>
      </tr>
    );
  };

  render() {
    const { scores } = this.props;

    return scores && scores.length > 0 ? (
      <Table
        items={scores.slice(0, 5)}
        renderItem={this.renderScoreRow}
        renderFooter={this.renderTableFooter}
        widths={["5%", "70%", "25%"]}
      />
    ) : (
      <p>Ei vielä myyntejä.</p>
    );
  }
}

const mapStateToProps = state => {
  const scores = getTopTeamScores(state);
  const currentUser = getCurrentUser(state);
  const teamPosition = getCurrentUserTeamPosition(state);
  return {
    currentUser,
    scores,
    teamPosition
  };
};

const ConnectedBestTeamsBlock = connect(
  mapStateToProps,
  Object.assign({}, teamActions)
)(BestTeamsBlock);

export default ConnectedBestTeamsBlock;



// WEBPACK FOOTER //
// ./src/modules/team/components/BestTeamsBlock.js